var Handlebars = require("../../node_modules/.pnpm/handlebars@4.7.8_patch_hash=53ad8d748fa2ca3a7a0502c46f2ed1236eef8162efec84c06849dc83ad9e28e9/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"input-element home-page-input pill-container\" id=\"left-sidebar-filter-topic-input\">\n            <div class=\"input\" contenteditable=\"true\" id=\"topic_filter_query\" data-placeholder=\""
    + container.escapeExpression(lookupProperty(helpers,"t").call(depth0 != null ? depth0 : (container.nullContext || {}),"Filter topics",{"name":"t","hash":{},"data":data,"loc":{"start":{"line":4,"column":96},"end":{"line":4,"column":118}}}))
    + "\"></div>\n        </div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"left-sidebar-filter-input-container\">\n"
    + ((stack1 = container.invokePartial(lookupProperty(partials,"input_wrapper"),undefined,{"name":"input_wrapper","hash":{"input_button_icon":"close","icon":"search","custom_classes":"topic_search_section filter-topics has-input-pills","input_type":"filter-input"},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "</div>\n";
},"usePartial":true,"useData":true});